<template>
  <router-view />
</template>

<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();

    onMounted(async () => {
      await store.dispatch('checkToken');
    });
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai+Looped&display=swap');
@import '../node_modules/vue-multiselect/dist/vue-multiselect.css';

* {
  font-family: "Noto Sans Thai Looped", sans-serif;
  font-weight: 400;
  font-style: normal;
}

a {
  text-decoration: none !important;
}

.input-group {
  z-index: -1;
}
</style>
